export default "__VITE_ASSET__BE3baefI__"